// extracted by mini-css-extract-plugin
export default {"table":"SubPO_table__zvMlU"};